/* eslint-disable */
import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, justifyContent, alignItems, flexDirection } from '../../styles/helpers/flexbox';

const AlertContainer = styled.div(props => {
    const { palette, typography } = ThemeHelper.getTheme(props);

    
    return `
    ${flexbox()}
    ${justifyContent('center')}
    ${alignItems('center')}
    ${flexDirection('column')}
    position: relative;
    color: ${palette.primary.dark};
    font-family: ${typography.family};
    `;
});

const AlertIcon = styled.div `
width: 60px;
height: 75px;
margin-bottom: 5px;
`;

const AlertTitle = styled.div(props => {
    const { palette } = ThemeHelper.getTheme(props);

    return `
    color: ${palette.primary.dark};
    margin: 10px 0;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    `;
});

const AlertSubTitle = styled.div(props => {
    const { palette } = ThemeHelper.getTheme(props);

    return `
    width: 60%;
    margin-top: 10px;
    margin-bottom: 50px;
    color: black;
    font-size: 20px;
    text-align: center;
    line-height: 27px;
    `;
});

export { AlertContainer, AlertIcon, AlertTitle, AlertSubTitle };



// WEBPACK FOOTER //
// ./app/components/alert/styled.js